import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box, Paper, Tab, Tabs, Typography, withStyles } from '@material-ui/core';
import { updateURL } from '../../sc-utilities';
import Documentation from './Documentation';
// import ApiKey from './ApiSetup'

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    paper: {
        marginTop: theme.spacing(),
        padding: theme.spacing(2),
    },
    tabs: {
        marginLeft: theme.spacing(-5)
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 6, marginTop: '1%' }}>
            {props.children}
        </Typography>
    );
};

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {(value === index || value < 3) && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const SecurazeAPI = props => {
    const { classes, theme, translations } = props;
    const [tabValue, setTabValue] = useState(getTabValue());

    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper} >
                <div className={classes.tabs}>
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="on"
                    >
                        {/* <Tab label={translations["api_setup"] || "API setup"} /> */}
                        <Tab label={translations["documentation"] || "Documentation"} />
                    </Tabs>
                </div>
            </Paper>
            {/* <TabPanel index={0} value={tabValue}>  <TabContainer style={{ padding: 0 }} dir={theme.direction}><ApiKey /></TabContainer></TabPanel> */}
            <TabPanel index={0} value={tabValue}>  <TabContainer style={{ padding: 0 }} dir={theme.direction}><Documentation /></TabContainer></TabPanel>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(SecurazeAPI));
